export const NAV_ITEMS = [
  { label: 'Home', homeHash: '#sobre' },
  { label: 'Sobre', page: '/quem-somos-innovanow' },
  { label: 'Soluções', homeHash: '#solucoes' },
  { label: 'Serviços', homeHash: '#servicos' },
  { label: 'Equipe', page: '/quem-somos-innovanow', hash: '#equipe' },
  { label: 'Aplicativos', homeHash: '#apps' },
  { label: 'Suporte', external: '/area/index.html' },
];

export const SOLUTIONS = [
  {
    icon: 'ri-customer-service-2-line',
    title: 'CRM integrado com Força de Vendas',
    description:
      'Gestão de negociações, funil comercial e clientes conectada ao app de vendas, ao ERP e ao WhatsApp Web. Organize conversas com a extensão oficial.',
    links: [
      { href: '/innova-crm', label: 'Conhecer o CRM →' },
      { href: '/crm/index.html', label: 'Acessar CRM →' },
      { href: '/app-vendas-personalizado.html', label: 'Força de Vendas →' },
    ],
  },
  {
    icon: 'ri-store-2-line',
    title: 'Força de Vendas',
    description:
      'App para representantes comerciais com catálogo, orçamentos, check-in no cliente e sincronização com o ERP — também disponível como app white label para sua empresa.',
    links: [
      { href: '/app-para-representante-comercial.html', label: 'Representante comercial →' },
      { href: '/app-vendas-personalizado.html', label: 'Saiba mais →' },
      {
        href: 'https://play.google.com/store/apps/developer?id=innova+now',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-file-list-3-line',
    title: '(in)nova OS — Ordem de Serviço',
    description:
      'Gestão completa de ordens de serviço para técnicos e administradores: atribuição, fotos, assinatura digital, materiais utilizados e notificações em tempo real.',
    links: [
      { href: '/innova-os', label: 'Saiba mais →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.com.innovanow.os',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'App de Holerites',
    description:
      'Plataforma para empresas enviarem holerites em PDF e colaboradores acessarem, baixarem e receberem notificações de forma segura pelo celular.',
    links: [
      { href: '/holerites/index.html', label: 'Acessar plataforma →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.com.innovanow.rh',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-parking-box-line',
    title: 'Gestão de Pátio',
    description:
      'Controle logístico de entrada e saída de veículos no pátio: check-in de motoristas, fila, status de chamada e notificações para operação em tempo real.',
    links: [
      { href: '/patio/index.html', label: 'Acessar plataforma →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.com.innovanow.inpatio',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-tools-line',
    title: 'CMMS — Manutenção',
    description:
      'Sistema de ordens de serviço e manutenção preventiva para equipes industriais e de facilities, com histórico de equipamentos e controle de custos.',
    links: [{ href: '/cmms-app-de-manutencao-preventiva.html', label: 'Saiba mais →' }],
  },
  {
    icon: 'ri-truck-line',
    title: 'Automação de CT-e',
    description:
      'Captura de dados do conhecimento de transporte por QR Code com envio direto ao ERP — elimina digitação manual e reduz erros no lançamento de frete.',
    links: [{ href: '/automatize-lancamento-de-frete.html', label: 'Saiba mais →' }],
  },
  {
    icon: 'ri-barcode-box-line',
    title: 'Automação Industrial',
    description:
      'Apps para coletores de dados: inventário, checkout, check-in e integração com seu ERP para operações de chão de fábrica e logística.',
    links: [{ href: '/criamos-seu-app.html', label: 'Saiba mais →' }],
  },
  {
    icon: 'ri-checkbox-multiple-line',
    title: '(in)nova Lean 5S',
    description:
      'Auditorias 5S digitais com modelos personalizáveis, fotos de evidência, respostas estruturadas e relatórios exportáveis para gestão da qualidade.',
    links: [
      { href: '/innova-lean-5s', label: 'Saiba mais →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.com.innova.lean5s',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-user-star-line',
    title: 'Instituto Inova / Jovem Aprendiz',
    description:
      'Plataforma para gestão educacional: jovens aprendizes, escolas, empresas e professores — presença, indicadores e acompanhamento do programa.',
    links: [
      { href: '/plataforma-web-jovem-aprendiz.html', label: 'Saiba mais →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.com.innovanow.inova',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-file-pdf-line',
    title: 'InnovaPDF',
    description:
      'Ferramenta prática para trabalhar com PDFs de forma offline, sem coleta de dados — simples, segura e disponível na Play Store.',
    links: [
      { href: '/politica-de-privacidade-innovapdf.html', label: 'Saiba mais →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.com.innovanow.innovapdf',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-run-line',
    title: 'Plusfit Sports',
    description:
      'App de incentivo à prática de atividades físicas com contador de passos e geração de relatórios em PDF para acompanhamento de metas.',
    links: [
      { href: '/politica-de-privacidade-plusfitsports.html', label: 'Saiba mais →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.ind.mcl.plusfitsports',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Power BI e DataViz',
    description:
      'Dashboards interativos para transformar dados operacionais e do ERP em indicadores de gestão para produção, vendas e manutenção.',
    links: [{ href: '#servicos', label: 'Saiba mais →' }],
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Apps White Label de Vendas',
    description:
      'Força de vendas personalizada com a marca do cliente — exemplos publicados: MCL Vendas, Agromak Vendas e Vendas DITRATOR.',
    links: [
      { href: '/criamos-seu-app.html', label: 'Criar o seu →' },
      {
        href: 'https://play.google.com/store/apps/details?id=br.ind.mcl.vendas',
        label: 'MCL →',
        external: true,
        className: 'play-link',
      },
      {
        href: 'https://play.google.com/store/apps/details?id=br.ind.agromak.vendas',
        label: 'Agromak →',
        external: true,
        className: 'play-link',
      },
      {
        href: 'https://play.google.com/store/apps/details?id=br.com.innovanow.ditrator',
        label: 'DITRATOR →',
        external: true,
        className: 'play-link',
      },
    ],
  },
  {
    icon: 'ri-code-box-line',
    title: 'Apps Personalizados',
    description:
      'Desenvolvimento sob medida de aplicativos Android, iOS e sistemas web para qualquer segmento — do conceito à publicação nas lojas.',
    links: [
      { href: '/criamos-seu-app.html', label: 'Saiba mais →' },
      {
        href: 'https://play.google.com/store/apps/developer?id=innova+now',
        label: 'Play Store →',
        external: true,
        className: 'play-link',
      },
    ],
  },
];

export const PROCESS_STEPS = [
  { number: 1, title: 'Diagnóstico', description: 'Entendemos seus processos, dores e objetivos com reuniões e levantamento de requisitos.' },
  { number: 2, title: 'Proposta', description: 'Apresentamos escopo, prazos e investimento alinhados à realidade do seu negócio.' },
  { number: 3, title: 'Desenvolvimento', description: 'Construímos o app ou sistema com acompanhamento e validações em cada etapa.' },
  { number: 4, title: 'Implantação', description: 'Testes, treinamento da equipe e publicação nas lojas ou ambiente de produção.' },
  { number: 5, title: 'Suporte', description: 'Acompanhamento pós-entrega, correções e evoluções conforme sua operação cresce.' },
];

export const SERVICE_BLOCKS = [
  {
    imageFirst: false,
    badge: 'Serviços',
    title: 'Sistemas e APPs Personalizados',
    description:
      'Cada empresa tem processos únicos. Por isso, a (in)nova now desenvolve apps e sistemas 100% personalizados — do levantamento de requisitos à implantação e suporte contínuo.',
    image: '/assets/images/automacao-industrial-sistemas-personalizados.webp',
    imageAlt: 'Desenvolvimento de aplicativos personalizados',
    imageWidth: 1200,
    imageHeight: 800,
    features: ['Adequação: necessidades, demandas', 'Produtividade: eficiência, qualidade', 'Inovação: diferenciação, oportunidades'],
  },
  {
    imageFirst: true,
    badge: 'Serviços',
    title: 'DataViz: Dashboards Power BI para sua operação',
    description:
      'Transformamos dados do seu ERP e da operação em dashboards Power BI interativos. Acompanhe indicadores de produção, vendas e manutenção em tempo real, com visualizações pensadas para gestores e equipes de chão de fábrica.',
    image: '/assets/images/desenvolvimento_de_aplicativos_moveis.webp',
    imageAlt: 'Android, iOS, Windows, e WEB',
    imageWidth: 1200,
    imageHeight: 800,
    features: ['Visualização Interativa de Dados', 'Análise Instantânea de Dados', 'Experiência de Usuário Intuitiva'],
  },
  {
    imageFirst: false,
    badge: 'Serviços',
    title: 'Soluções orientadas a dados para empresas',
    description:
      'A innovanow oferece soluções que impulsionam o sucesso das organizações, otimizando processos, embasando decisões e maximizando a eficiência operacional com dados reais do seu negócio.',
    image: '/assets/images/bi-chao-de-fabrica.webp',
    imageAlt: 'Power BI para sua indústria',
    imageWidth: 1200,
    imageHeight: 800,
    features: ['Otimização de Processos Empresariais', 'Tomada de Decisões Embasada em Dados', 'Maximização da Eficiência Operacional'],
  },
];

export const CLIENT_SLIDES = [
  [
    { image: '/assets/images/mcl.webp', name: 'MCL Peças Agrícolas', city: 'Palotina' },
    { image: '/assets/images/friolog.png', name: 'FRIOLOG', city: 'Maripá' },
    { image: '/assets/images/demac.png', name: 'Demac Peças Agrícolas', city: 'Palotina' },
  ],
  [
    { image: '/assets/images/terra.webp', name: 'Colégio Terra do Saber', city: 'Palotina' },
    { image: '/assets/images/fabrica.png', name: 'Fábrica de Águias', city: 'São Paulo' },
    { image: '/assets/images/agromak.png', name: 'Agromak', city: 'Jandaia do Sul' },
  ],
  [
    { image: '/assets/images/inova.png', name: 'Instituto Inova', city: 'Palotina' },
    { image: '/assets/images/mcl.webp', name: 'MCL Peças Agrícolas', city: 'Palotina' },
    { image: '/assets/images/friolog.png', name: 'FRIOLOG', city: 'Maripá' },
  ],
];

export const TESTIMONIALS = [
  {
    quote:
      'Com o app de força de vendas, nossa equipe comercial passou a registrar pedidos direto do campo, com os dados sincronizados ao ERP sem retrabalho.',
    image: '/assets/images/mcl.webp',
    name: 'MCL Peças Agrícolas',
    role: 'Palotina — Agronegócio',
    imageWidth: 1024,
    imageHeight: 1024,
  },
  {
    quote:
      'A gestão de manutenção saiu do papel. Hoje controlamos ordens de serviço e preventivas pelo celular, com histórico completo de cada equipamento.',
    image: '/assets/images/friolog.png',
    name: 'FRIOLOG',
    role: 'Maripá — Indústria',
    imageWidth: 1024,
    imageHeight: 1024,
  },
  {
    quote:
      'A automação com coletores de dados agilizou nosso inventário e reduziu erros de lançamento no estoque. A integração com o ERP foi o diferencial.',
    image: '/assets/images/mcl.webp',
    name: 'MCL Peças Agrícolas',
    role: 'Palotina — Agronegócio',
    imageWidth: 1024,
    imageHeight: 1024,
  },
];

export const PORTFOLIO = [
  {
    image: '/assets/images/vendas.webp',
    imageWidth: 1080,
    imageHeight: 765,
    title: 'Força de Vendas',
    result: '✓ Pedidos em campo com sync em tempo real ao ERP',
    description:
      'Nosso aplicativo de força de vendas é um verdadeiro aliado personalizado, moldando-se conforme as necessidades de cada cliente.',
    href: '/app-vendas-personalizado.html',
    linkLabel: 'Saiba mais sobre desenvolvimento de aplicativo de vendas para representante comercial',
  },
  {
    image: '/assets/images/cmms.webp',
    imageWidth: 1080,
    imageHeight: 765,
    title: 'CMMS — Sistema de Manutenção',
    result: '✓ Manutenção preventiva 100% digital',
    description:
      'Com um sistema inteligente de ordens de manutenção você abandona os papéis, elevando a produtividade e controle de custo. Preserve os equipamentos, implemente uma gestão CMMS eficiente e opere com excelência.',
    href: '/cmms-app-de-manutencao-preventiva.html',
    linkLabel: 'Saiba mais sobre desenvolvimento de aplicativo cmms para o time de manutenção da sua empresa',
  },
  {
    image: '/assets/images/checkout.webp',
    imageWidth: 1200,
    imageHeight: 800,
    title: 'Automação de Processos',
    result: '✓ Inventário e checkout com coletores de dados',
    description:
      'Desenvolvemos aplicativos de automação para coletores de dados, como checkout e checkin de produtos, inventários, controle de estoque, além de integrações personalizadas com o seu ERP.',
    href: 'https://wa.me/5544991775641',
    linkLabel: 'Saiba mais sobre desenvolvimento de sistema de automação industrial com usos de coletores de dados',
    external: true,
  },
  {
    image: '/assets/images/cte_1.webp',
    imageWidth: 1080,
    imageHeight: 765,
    title: 'Automação CTe',
    result: '✓ Lançamento de frete por QR Code, sem digitação',
    description:
      'Chega de digitação manual e processos demorados! Com nosso app, basta escanear o QR Code da nota de CTe e todas as informações são capturadas e enviadas diretamente para o seu ERP. Mais rapidez, menos erros e muito mais produtividade!',
    href: '/automatize-lancamento-de-frete.html',
    linkLabel: 'Saiba mais sobre automação de CT-e',
  },
  {
    image: '/assets/images/plataforma-jovem-aprendiz.webp',
    imageWidth: 1080,
    imageHeight: 765,
    title: 'Plataforma para Jovem Aprendiz',
    result: '✓ Gestão para escolas, empresas e aprendizes',
    description: 'Sistema WEB desenvolvido para atender jovens, professores, escolas e empresas.',
    href: '/plataforma-web-jovem-aprendiz.html',
    linkLabel: 'Saiba mais sobre este projeto',
  },
  {
    image: '/assets/images/plataforma-gestao-de-patio.jpg',
    imageWidth: 1080,
    imageHeight: 765,
    title: 'Plataforma para Gestão de Pátio',
    result: '✓ Controle logístico de entrada e saída de veículos',
    description: 'Sistema WEB desenvolvido para atender logística de pátio.',
    href: '/patio',
    linkLabel: 'Saiba mais sobre este projeto',
  },
];

export const FAQ_ITEMS = [
  {
    question: 'Que tipo de aplicativos a (in)nova now desenvolve?',
    answer:
      'A (in)nova now — também buscada como innova now ou innovanow — desenvolve apps Android, iOS e sistemas web personalizados, incluindo força de vendas, CMMS, automação com coletores de dados e integração com ERPs.',
  },
  {
    question: 'A (in)nova now atende empresas fora de Palotina?',
    answer:
      'Sim. A (in)nova now atende empresas em todo o Brasil, com equipe remota e presencial conforme a necessidade do projeto.',
  },
  {
    question: 'Quanto tempo leva para desenvolver um aplicativo?',
    answer:
      'O prazo varia conforme a complexidade. Projetos simples levam de 4 a 8 semanas; sistemas integrados a ERP podem levar de 3 a 6 meses.',
  },
  {
    question: 'Quanto custa desenvolver um aplicativo ou sistema?',
    answer:
      'O investimento depende do escopo, integrações e plataformas (Android, iOS, web). Após entender sua necessidade, enviamos uma proposta personalizada sem compromisso.',
  },
  {
    question: 'Vocês fazem manutenção após a entrega do projeto?',
    answer:
      'Sim. Oferecemos suporte contínuo, correções e evoluções do sistema conforme sua operação cresce e novas demandas surgem.',
  },
  {
    question: 'O aplicativo funciona sem internet?',
    answer:
      'Sim. Desenvolvemos apps com modo offline para operações em campo ou chão de fábrica, com sincronização automática quando a conexão retorna.',
  },
  {
    question: 'É possível integrar com o ERP que já usamos?',
    answer:
      'Sim. A (in)nova now tem experiência em integrações personalizadas com ERPs e sistemas legados, conectando apps e automações ao fluxo que sua empresa já utiliza.',
  },
];

export const CITY_LINKS = [
  { href: '/desenvolvimento-de-sistema-ou-app-em-palotina', label: 'Palotina' },
  { href: '/desenvolvimento-de-sistema-ou-app-em-toledo', label: 'Toledo' },
  { href: '/desenvolvimento-de-sistema-ou-app-em-cascavel', label: 'Cascavel' },
  { href: '/desenvolvimento-de-sistema-ou-app-em-maripa', label: 'Maripá' },
  { href: '/desenvolvimento-de-sistema-ou-app-em-ipora', label: 'Iporã' },
  { href: '/desenvolvimento-de-sistema-ou-app-em-francisco-alves', label: 'Francisco Alves' },
  { href: '/desenvolvimento-de-sistema-ou-app-em-assis-chateaubriand', label: 'Assis Chateaubriand' },
  { href: '/criacao-de-site-em-palotina', label: 'Criação de site — Palotina' },
  { href: '/criacao-de-site-em-toledo', label: 'Criação de site — Toledo' },
  { href: '/criacao-de-site-em-terra-roxa', label: 'Criação de site — Terra Roxa' },
];

export const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/innova_now/',
    icon: 'ri-instagram-line',
  },
  {
    label: 'Google Play',
    href: 'https://play.google.com/store/apps/developer?id=innova+now',
    icon: 'ri-google-play-line',
  },
  {
    label: 'App Store',
    href: 'https://apps.apple.com/br/developer/in-nova-now-tech/id1790867569',
    icon: 'ri-apple-line',
  },
];

export const CULTURE_ITEMS = [
  { icon: 'ri-heart-3-fill', title: 'Missão', text: 'Otimizar resultados, inovando no acesso as informações por meio de soluções tecnologicas.' },
  { icon: 'ri-eye-fill', title: 'Visão', text: 'Ser reconhecido pelos HUBS de Tecnologia, como Startup com foco em resultados em 5 ano no Paraná.' },
  {
    icon: 'ri-vip-diamond-fill',
    title: 'Valores',
    text: 'Guiados por valores sólidos, oferecemos soluções que garantem a integridade e a segurança dos dados, com comprometimento total e inovação constante;',
  },
  {
    icon: 'ri-pen-nib-fill',
    title: 'Propósito',
    text: 'Somos a força que otimiza resultados, inovando por meio de soluções tecnológicas, para que as organizações alcancem todo o seu potencial na era digital.',
  },
  { icon: 'ri-rocket-2-fill', title: 'Resultado', text: 'Proporcionamos resultados para as organizações empresariais;' },
  { icon: 'ri-pencil-ruler-2-fill', title: 'Integração', text: 'Somos agentes de integração e transformação digital;' },
];
